"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Banda App API
 * The API for the Banda App
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventUserControllerApi = exports.EventUserControllerApiFactory = exports.EventUserControllerApiFp = exports.EventUserControllerApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * EventUserControllerApi - axios parameter creator
 * @export
 */
const EventUserControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [userId]
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {boolean} [withIntruments]
         * @param {AttendanceStatus} [attendanceStatusFilter]
         * @param {boolean} [withEquipment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserGet: (userId, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withIntruments, attendanceStatusFilter, withEquipment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/eventUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (searchField !== undefined) {
                localVarQueryParameter['searchField'] = searchField;
            }
            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }
            if (withIntruments !== undefined) {
                localVarQueryParameter['withIntruments'] = withIntruments;
            }
            if (attendanceStatusFilter !== undefined) {
                localVarQueryParameter['attendanceStatusFilter'] = attendanceStatusFilter;
            }
            if (withEquipment !== undefined) {
                localVarQueryParameter['withEquipment'] = withEquipment;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventUserIdDelete', 'id', id);
            const localVarPath = `/api/eventUser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventUserIdGet', 'id', id);
            const localVarPath = `/api/eventUser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {EventUserPut} eventUserPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserIdPut: (id, eventUserPut, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiEventUserIdPut', 'id', id);
            // verify required parameter 'eventUserPut' is not null or undefined
            (0, common_1.assertParamExists)('apiEventUserIdPut', 'eventUserPut', eventUserPut);
            const localVarPath = `/api/eventUser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eventUserPut, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {EventUserPost} eventUserPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserPost: (eventUserPost, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventUserPost' is not null or undefined
            (0, common_1.assertParamExists)('apiEventUserPost', 'eventUserPost', eventUserPost);
            const localVarPath = `/api/eventUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eventUserPost, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {MultipleEventUserPut} multipleEventUserPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserPut: (multipleEventUserPut, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'multipleEventUserPut' is not null or undefined
            (0, common_1.assertParamExists)('apiEventUserPut', 'multipleEventUserPut', multipleEventUserPut);
            const localVarPath = `/api/eventUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(multipleEventUserPut, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {BulkUpdateEventUsers} bulkUpdateEventUsers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserPutBulkPut: (bulkUpdateEventUsers, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'bulkUpdateEventUsers' is not null or undefined
            (0, common_1.assertParamExists)('apiEventUserPutBulkPut', 'bulkUpdateEventUsers', bulkUpdateEventUsers);
            const localVarPath = `/api/eventUser/putBulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkUpdateEventUsers, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EventUserControllerApiAxiosParamCreator = EventUserControllerApiAxiosParamCreator;
/**
 * EventUserControllerApi - functional programming interface
 * @export
 */
const EventUserControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EventUserControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [userId]
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {boolean} [withIntruments]
         * @param {AttendanceStatus} [attendanceStatusFilter]
         * @param {boolean} [withEquipment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserGet(userId, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withIntruments, attendanceStatusFilter, withEquipment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventUserGet(userId, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withIntruments, attendanceStatusFilter, withEquipment, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventUserIdDelete(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventUserIdGet(id, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {EventUserPut} eventUserPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserIdPut(id, eventUserPut, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventUserIdPut(id, eventUserPut, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {EventUserPost} eventUserPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserPost(eventUserPost, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventUserPost(eventUserPost, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {MultipleEventUserPut} multipleEventUserPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserPut(multipleEventUserPut, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventUserPut(multipleEventUserPut, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {BulkUpdateEventUsers} bulkUpdateEventUsers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserPutBulkPut(bulkUpdateEventUsers, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiEventUserPutBulkPut(bulkUpdateEventUsers, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.EventUserControllerApiFp = EventUserControllerApiFp;
/**
 * EventUserControllerApi - factory interface
 * @export
 */
const EventUserControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EventUserControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [userId]
         * @param {string} [searchField]
         * @param {string} [searchString]
         * @param {number} [pageSize]
         * @param {number} [pageNumber]
         * @param {string} [sortBy]
         * @param {string} [sortOrder]
         * @param {boolean} [withIntruments]
         * @param {AttendanceStatus} [attendanceStatusFilter]
         * @param {boolean} [withEquipment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserGet(userId, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withIntruments, attendanceStatusFilter, withEquipment, options) {
            return localVarFp.apiEventUserGet(userId, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withIntruments, attendanceStatusFilter, withEquipment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserIdDelete(id, options) {
            return localVarFp.apiEventUserIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserIdGet(id, options) {
            return localVarFp.apiEventUserIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {EventUserPut} eventUserPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserIdPut(id, eventUserPut, options) {
            return localVarFp.apiEventUserIdPut(id, eventUserPut, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {EventUserPost} eventUserPost
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserPost(eventUserPost, options) {
            return localVarFp.apiEventUserPost(eventUserPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {MultipleEventUserPut} multipleEventUserPut
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserPut(multipleEventUserPut, options) {
            return localVarFp.apiEventUserPut(multipleEventUserPut, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {BulkUpdateEventUsers} bulkUpdateEventUsers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEventUserPutBulkPut(bulkUpdateEventUsers, options) {
            return localVarFp.apiEventUserPutBulkPut(bulkUpdateEventUsers, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EventUserControllerApiFactory = EventUserControllerApiFactory;
/**
 * EventUserControllerApi - object-oriented interface
 * @export
 * @class EventUserControllerApi
 * @extends {BaseAPI}
 */
class EventUserControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {number} [userId]
     * @param {string} [searchField]
     * @param {string} [searchString]
     * @param {number} [pageSize]
     * @param {number} [pageNumber]
     * @param {string} [sortBy]
     * @param {string} [sortOrder]
     * @param {boolean} [withIntruments]
     * @param {AttendanceStatus} [attendanceStatusFilter]
     * @param {boolean} [withEquipment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventUserControllerApi
     */
    apiEventUserGet(userId, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withIntruments, attendanceStatusFilter, withEquipment, options) {
        return (0, exports.EventUserControllerApiFp)(this.configuration).apiEventUserGet(userId, searchField, searchString, pageSize, pageNumber, sortBy, sortOrder, withIntruments, attendanceStatusFilter, withEquipment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventUserControllerApi
     */
    apiEventUserIdDelete(id, options) {
        return (0, exports.EventUserControllerApiFp)(this.configuration).apiEventUserIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventUserControllerApi
     */
    apiEventUserIdGet(id, options) {
        return (0, exports.EventUserControllerApiFp)(this.configuration).apiEventUserIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {EventUserPut} eventUserPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventUserControllerApi
     */
    apiEventUserIdPut(id, eventUserPut, options) {
        return (0, exports.EventUserControllerApiFp)(this.configuration).apiEventUserIdPut(id, eventUserPut, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {EventUserPost} eventUserPost
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventUserControllerApi
     */
    apiEventUserPost(eventUserPost, options) {
        return (0, exports.EventUserControllerApiFp)(this.configuration).apiEventUserPost(eventUserPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {MultipleEventUserPut} multipleEventUserPut
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventUserControllerApi
     */
    apiEventUserPut(multipleEventUserPut, options) {
        return (0, exports.EventUserControllerApiFp)(this.configuration).apiEventUserPut(multipleEventUserPut, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {BulkUpdateEventUsers} bulkUpdateEventUsers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventUserControllerApi
     */
    apiEventUserPutBulkPut(bulkUpdateEventUsers, options) {
        return (0, exports.EventUserControllerApiFp)(this.configuration).apiEventUserPutBulkPut(bulkUpdateEventUsers, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EventUserControllerApi = EventUserControllerApi;
